var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 14.5H3.3335C3.06016 14.5 2.8335 14.2733 2.8335 14C2.8335 13.7267 3.06016 13.5 3.3335 13.5H12.6668C12.9402 13.5 13.1668 13.7267 13.1668 14C13.1668 14.2733 12.9402 14.5 12.6668 14.5Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 11.8333C5.1535 11.8333 2.8335 9.51333 2.8335 6.66667V2C2.8335 1.72667 3.06016 1.5 3.3335 1.5C3.60683 1.5 3.8335 1.72667 3.8335 2V6.66667C3.8335 8.96667 5.70016 10.8333 8.00016 10.8333C10.3002 10.8333 12.1668 8.96667 12.1668 6.66667V2C12.1668 1.72667 12.3935 1.5 12.6668 1.5C12.9402 1.5 13.1668 1.72667 13.1668 2V6.66667C13.1668 9.51333 10.8468 11.8333 8.00016 11.8333Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextUnderline);
export default __webpack_public_path__ + "static/media/text-underline.f6f90230.svg";
export { ForwardRef as ReactComponent };